import { useLang } from '@/i18n';
import EcoScrollLR from 'eco-design/base/eco-scroll-l-r';
import EcoCountDown from 'eco-design/elements/eco-count-down';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoBundleCommonCard, { EcoBundleCommonCardProps } from 'eco-design/sections-test/eco-bundle-common-card';
import { Fragment, useCallback, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useProductStore } from '@elem/compPage/wave-3-and-glacier-classic/ProductProvider';
import { IPageStatus } from '@elem/compPage/wave-3-and-glacier-classic/config/IPageStatus';
import { useRouter } from 'next/router';
import { getSolarRecommand } from '@/service/solar-calculator';
import EfBundlesActivity from '@elem/ui/ef-bundles-activity';
import { getListProducts } from '@/service/membersstore';
import { ProductModule } from '@/components/MembersDay/type';
import ItemB from './ItemB';
import gtm from 'eco-design-reliance/gtm';
import EcoSpace from 'eco-design/base/eco-space';

export interface ProductType {
    img?: string;
    name?: string;
    discountPrice?: string;
    originalPrice?: string;
    quantity?: string;
    buyStatus?: string;
    buyText?: string;
    list_name?: string;
    moreLink?: string;
    inventoryQuantity?: boolean;
    productId: string;
    variantId: string;
    ldataLayer: object;
}

export default function Comp() {
    const { t } = useLang('theProduct.ActivityA3');
    const { pageStatus } = useProductStore();
    const { locale = 'jp' } = useRouter();
    const [products, setProducts] = useState<ProductType[]>([]);

    const isNextTimer = pageStatus !== IPageStatus.statusA && pageStatus !== IPageStatus.statusB;

    const buyText = isNextTimer ? t('buy_text2') : t('buy_text1'); //购买按钮-文案
    const buyStatus = isNextTimer ? 'default' : 'disabled'; //购买按钮-链接
    const list_name = pageStatus === IPageStatus.statusC ? t('title2') : t('title');

    const [itemsA, setItemsA] = useState([
        {
            productId: '14692433133935',
            variantId: '51919145959791',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
            // ldataLayer: {
            //     event: 'uaEvent',
            //     event_name: 'buy',
            //     product_name: 'pro-grade UPS for precision gear',
            //     position: 'Collections_wave-3-and-glacier-classic',
            // },
        },
        {
            productId: '14689202667887',
            variantId: '51927572021615',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14695816069487',
            variantId: '51927575560559',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14696915075439',
            variantId: '51927575789935',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14694862815599',
            variantId: '51927575986543',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14695837630831',
            variantId: '51927670456687',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14695060210031',
            variantId: '51927582966127',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
        {
            productId: '14692240195951',
            variantId: '51927583097199',
            quantity: 1,
            buyStatus,
            buyText,
            list_name,
        },
    ]);

    // 调用接口获取产品信息
    const getAsynItem = useCallback(
        (item: ProductType) => {
            const newItem = JSON.parse(JSON.stringify(item)) as ProductType;
            const { productId, variantId } = newItem;
            return new Promise<ProductType>(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    const data = res?.data;
                    if (res?.code === '0') {
                        // title
                        newItem.name = data.skuTitle && data.skuTitle !== 'Default Title' ? data.skuTitle : data?.productTitle;
                        // 价格
                        newItem.discountPrice = data?.price;
                        // 划线价
                        newItem.originalPrice = data?.compareAtPrice !== data?.price ? data?.compareAtPrice : null;
                        //库存
                        newItem.inventoryQuantity = isNextTimer ? data?.inventoryQuantity ?? 0 : 10;

                        newItem.moreLink = isNextTimer && data?.inventoryQuantity ? `https://www.ecoflow.com/${locale}/wave-3-portable-air-conditioner` : '';
                        newItem.ldataLayer = {
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: data.skuTitle && data.skuTitle !== 'Default Title' ? data.skuTitle : data?.productTitle,
                            position: 'Collections_wave-3-and-glacier-classic',
                        };
                        //产品图
                        if (data?.img || data.variantImg) {
                            newItem.img = data.variantImg || data?.img;
                        }
                        return resolve(newItem);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        },
        [locale],
    );
    useEffect(() => {
        const promises = itemsA?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then(setProducts)
            .catch((e) => {
                console.error(e);
            });
    }, [getAsynItem]);

    return (
        <div className={styles.comp} id="ActivityA3">
            <EcoSpace />
            <EcoSectionCommon title={pageStatus !== IPageStatus.statusD ? t('title1') : t('title2')} />
            {pageStatus !== IPageStatus.statusD && (
                <div className="common-page-desc">
                    <span className="page-section-timer-icon"></span>
                    {t('desc')}
                </div>
            )}
            {pageStatus !== IPageStatus.statusD && (
                <div className="common-page-countdown">
                    <div className="common-page-countdown-l">
                        {pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB ? t('timer_l') : t('timer_end_l')}
                    </div>

                    <EcoCountDown
                        endTime={
                            pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB ? '2025/04/28 10:00:00 GMT+8' : '2025/05/07 23:00:00 GMT+8'
                        }
                        className="common-page-countdown-r"
                        tipsDay="日"
                        tipsHour="時"
                        tipsMinute="分"
                        tipsSecond="秒"
                    />
                </div>
            )}
            <div className="ActivityA3-list eco-content">
                {products.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfBundlesActivity
                                {...item}
                                isNeedLogin={false}
                                btnText={{
                                    price1_front: '限定価格：',
                                    price2_front: '通常価格：',
                                    link_more: '詳細はこちら',
                                    link_buy: '今すぐ購入',
                                    sold_out: '完売',
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>
            <div className="ActivityA3-tips">
                {pageStatus !== IPageStatus.statusD && (
                    <p>
                        {t.rich('tips', {
                            line1: (children: any) => (
                                <a
                                    className="ActivityA3-tips-line"
                                    href="https://jp.ecoflow.com/products/carry-wagon"
                                    onClick={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: children[0],
                                            position: 'Collections_wave-3-and-glacier-classic',
                                        });
                                    }}
                                >
                                    {children}
                                </a>
                            ),
                        })}
                    </p>
                )}
                <p>{t('tips2')}</p>
            </div>
        </div>
    );
}
